import Table from "../table/Table";
import LockTableSelectionController from "./LockTableSelectionController";
import TableRegion from "../table/TableRegion";
import {getEventObj} from "../atBrowserUtils"
import LockTableHoverController from "./LockTableHoverController";
import LockTableMouseEventsHandler from "./LockTableMouseEventsHandler";
import NullTableRegion from "../table/NullTableRegion";

export default class LockTable extends Table {
    constructor(todayDate, weekStartDay) {
        super();
        this.listeners = [];
        this.viewerTodayDate = todayDate;
        this.viewerTodayColIdx = -1;
        this.weekStartDay = weekStartDay;
        this.datesRow = null;
        this.tooltipController = null;
        this.commentsController = null;
        this.runnerController = null;
    }

    createSelectionController() {
        return new LockTableSelectionController();
    }

    createHoverController() {
        return new LockTableHoverController();
    }

    createMouseEventsHandler() {
        var lockTableMouseEventsHandler = new LockTableMouseEventsHandler(this, this.getSelectionController(), this.getHoverController(),
            this.getRunnerController());
        var table = this;
        lockTableMouseEventsHandler.addSelectionFinishedListener(
            function(mouseUpEvent) {
                table.fireSelectionFinished(getEventObj(mouseUpEvent));
            }
        );
        return lockTableMouseEventsHandler;
    }

    init(runnerController, tooltipController, commentsController) {
        this.runnerController = runnerController;
        this.tooltipController = tooltipController;
        this.commentsController = commentsController;

        // TODO: remove mouseEventsHandler initialization and call Table.prototype.init method after Table class refactoring, now is calling in constructor
        this.mouseEventsHandler = this.createMouseEventsHandler();

        var self = this;
        commentsController.addViewCommentsListener({
            onViewComments() {
                self.setIgnoreUserActivity(true);
                self.hoverController.unhover();
                tooltipController.enableTooltips(false);
            },

            onCloseComments() {
                self.setIgnoreUserActivity(false);
                tooltipController.enableTooltips(true);
            }
        });

        this.selectionController.addSelectionChangeListener(function(selectionChangeEvent) {
            if (selectionChangeEvent.newValue == NullTableRegion) {
                commentsController.enableComments(true);
                tooltipController.enableTooltips(true);
            }
            else {
                commentsController.enableComments(false);
                tooltipController.enableTooltips(false);
            }
        });

    }

    getHoverController() {
        return this.hoverController;
    }

    getRunnerController() {
        return this.runnerController;
    }

    getCommentsController() {
        return this.commentsController;
    }

    getTooltipController() {
        return this.tooltipController;
    }

    containsViewerTodayColumn() {
        return this.viewerTodayColIdx > 0;
    }

    getViewerTodayColIdx() {
        return this.viewerTodayColIdx;
    }

    addDatesRow(datesRow) {
        this.addRow(datesRow);
        this.datesRow = datesRow;

        for (var colIdx = 1; colIdx < datesRow.getCells().length; colIdx++) {
            if (datesRow.getCell(colIdx).getValue().date.getTime() == this.viewerTodayDate.getTime()) {
                this.viewerTodayColIdx = colIdx;
                break;
            }
        }
    }

    getDatesRow() {
        return this.datesRow;
    }

    selectionChanged(selectionChangeEvent) {
        var updateRegion = this.computeChangedRegion(selectionChangeEvent);

        if (updateRegion != NullTableRegion) {
            //should update selection bottom border
            if (updateRegion.rowMax < this.rows.length - 1)
                updateRegion = new TableRegion(updateRegion.rowMin, updateRegion.colMin, updateRegion.rowMax + 1, updateRegion.colMax);

            //should update selection right border
            if (updateRegion.colMax < this.getLastRow().getCells().length - 1)
                updateRegion = new TableRegion(updateRegion.rowMin, updateRegion.colMin, updateRegion.rowMax, updateRegion.colMax + 1);

            this.updateCellRegionUI(updateRegion);

            //update marked selected dates
            if (updateRegion.rowMin > 0)
                for (var colIdx = updateRegion.colMin; colIdx <= updateRegion.colMax; colIdx++)
                    this.getDatesRow().updateCellUI(colIdx);

            for (var rowIdx = updateRegion.rowMin; rowIdx <= updateRegion.rowMax; rowIdx++)
                this.rows[rowIdx].updateCellUI(0);
        } else if (selectionChangeEvent.oldValue == NullTableRegion ||
                   selectionChangeEvent.newValue == NullTableRegion) {
            var userRows = this.getUserRows();
            for (var userRowIdx = 0; userRowIdx < userRows.length; userRowIdx++)
                userRows[userRowIdx].updateCellUI(0);
        }

        if (selectionChangeEvent.newValue != NullTableRegion)
            this.fireSelectionRemoved();
    }

    hoverChanged(regionChangeEvent) {
        if (regionChangeEvent.oldValue != NullTableRegion)
            this.updateCellRegionUI(regionChangeEvent.oldValue);
        if (regionChangeEvent.newValue != NullTableRegion)
            this.updateCellRegionUI(regionChangeEvent.newValue);
    }

    addLockEventsListener(listener) {
        this.listeners.push(listener);
    }

    fireSelectionFinished(mouseUpEvent) {
        if (this.selectionController.hasSelection()) {
            var selection = this.getSelectionController().getSelection();
            for (var i = 0; i < this.listeners.length; i++)
                this.listeners[i].selectionFinished(selection, mouseUpEvent);
        }
    }

    fireSelectionRemoved() {
        for (var i = 0; i < this.listeners.length; i++)
            this.listeners[i].selectionRemoved();
    }

    fireUserCellClicked(userDayCell) {
        for (var i = 0; i < this.listeners.length; i++) {
            this.listeners[i].userDayClicked(
                userDayCell.getRow().getHeaderCell().getValue().id,
                this.getDatesRow().getCell(userDayCell.getColIdx()).getValue().date,
                userDayCell
            );
        }
    }

    /**
     * Gets user rows from specified row range.
     * Returns all user rows if row range not specified.
     *
     * @param startRowIdx - range start
     * @param endRowIdx - range end
     */
    getUserRows(startRowIdx, endRowIdx) {
        var startIdx = startRowIdx ? startRowIdx : 0;
        var endIdx = endRowIdx ? endRowIdx : (this.rows.length - 1);

        var userRows = [];
        for (var i = startIdx; i <= endIdx; i++) {
            var currentRow = this.rows[i];
            var isUserRow = currentRow.accept({
                visitUserRow(cell) { return true; },
                visitDetailsRow(cell) { return false; },
                visitDatesRow(cell) { return false; },
                visitRunnerRow(cell) { return false; },
                visitInactiveRow(cell) { return false; }
            }, null);

            if (isUserRow)
                userRows.push(currentRow);
        }
        return userRows;
    }

    getLastSelectableRow() {
        for (var i = this.rows.length - 1; i > 0; i--) {
            var row = this.rows[i];
            var isSelectableRow = row.accept({
                visitUserRow(cell) { return true; },
                visitDetailsRow(cell) { return true; },
                visitDatesRow(cell) { return true; },
                visitRunnerRow(cell) { return true; },
                visitInactiveRow(cell) { return false; }
            }, null);

            if (isSelectableRow)
                return row;
        }
    }

    setIgnoreUserActivity(ignore) {
        this.getMouseEventsHandler().setIgnoreMouseEvents(ignore);

        var userRows = this.getUserRows();
        for (var i = 0; i < userRows.length; i++) {
            userRows[i].disableExpandCollapse(ignore);
        }
    }

    getWeekStartDay() {
        return this.weekStartDay;
    }

    isHolidayColumn(colIdx) {
        return !this.getDatesRow().getCell(colIdx).getValue().working;
    }

    updateCellRegionUI(region) {
        // update main region and update also cells that appears right from that region
        for (var rowIdx = region.rowMin; rowIdx <= region.rowMax; rowIdx++)
            for (var colIdx = region.colMin; colIdx <= Math.min(region.colMax + 1, this.getLastRow().getCells().length - 1); colIdx++)
                this.rows[rowIdx].updateCellUI(colIdx);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTable.js